import { QuoteInput, StudentDetails } from '@lx/quote-tool/shared/types';
import { CityExtended, Country, CourseType } from '@lx/shared/data-access/types';

export interface PriceRequestFormState {
  quoteInput?: QuoteInput;
  studentDetails?: StudentDetails;
  courseType?: CourseType;
  destinationCountries?: Country[];
  destinationCities?: CityExtended[];
  courseTypes?: string[];
}

export const defaultPriceRequestExperimentState: PriceRequestFormState = {};
